module.exports = __webpack_public_path__ + "static/media/m-geoshade.95910862.pdf";